// The After loading mark: the "A" with its arc swept by a sliding mask.
// Sized by the caller (the SVG fills its box) and drawn in currentColor,
// so it sits inside a button, over a placeholder, or on its own.

export default function ArcLoading({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1060 260"
      className={className}
      role="status"
      aria-label="Loading"
    >
      <defs>
        <clipPath id="arc-loading-clip">
          <rect width="1060" height="260" fill="white" />
        </clipPath>
        <mask
          id="arc-loading-mask"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="1060"
          height="260"
        >
          <rect
            x="-1060"
            y="0"
            width="1060"
            height="260"
            fill="white"
            style={{ animation: "arc-loading-sweep 2.4s infinite" }}
          />
        </mask>
        <style>
          {`@keyframes arc-loading-sweep {
              0% { transform: translateX(0); animation-timing-function: ease-out; }
              50% { transform: translateX(100%); animation-timing-function: ease-out; }
              100% { transform: translateX(200%); }
            }`}
        </style>
      </defs>
      <g clipPath="url(#arc-loading-clip)">
        <path
          d="M211.36 259.72L184.76 229.31L152.45 139.15L148.23 126.69L102.62 0H72L86.99 27.66C80.03 45.4 8.02 250.85 0 259.72H54.26L29.14 231.85C30.19 228.89 44.34 189.83 44.76 188.35L51.52 169.14L95.02 46.88L126.69 134.5L131.12 146.96C139.99 171.25 153.72 209.04 162.59 233.54L150.13 259.72H211.36Z"
          fill="currentColor"
        />
        <path
          d="M909.31 146.12C682.11 51.5199 379.95 50.2499 147.89 126.48L126.35 134.29C116.42 138.09 106.92 141.89 97.42 146.12C80.74 153.3 65.32 160.9 50.97 168.92L36.19 177.16C31.75 190.25 30.48 193.63 29 196.79L44.42 187.93C69.55 172.72 101.43 157.73 130.99 146.54L152.32 138.73C395.78 56.5899 816.83 56.7999 1018.9 230.58L1005.39 259.51H1059.66C1033.26 216.85 982.16 177.79 909.31 146.12Z"
          fill="currentColor"
          mask="url(#arc-loading-mask)"
        />
      </g>
    </svg>
  );
}
